var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"container",tag:"component",staticClass:"cs-slide",style:(_vm.style),attrs:{"attrs":_vm.attrs},on:{"transitionend":function($event){return _vm.onTransitionEnd($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }